"use client";

import { Footer } from "@/app/components/Footer";
import { Image } from "@/app/components/Image";
import NavbarSnowsense from "@/app/components/NavbarSnowsense";
import { ScrollReveal } from "@/app/components/ScrollReveal";
import { Container, RuleBlock, Section, SitePage } from "@/app/components/SiteUi";
import { useI18n } from "@/lib/i18n";

export default function Umfyrirtaekid() {
	const { t } = useI18n();

	const items = [
		"company_page.item_install",
		"company_page.item_light",
		"company_page.item_conditions",
		"company_page.item_pole",
		"company_page.item_avalanche",
		"company_page.item_other_uses",
	];

	return (
		<SitePage>
			<NavbarSnowsense />

			<main>
				<h1 className="sr-only">POLS Engineering ehf</h1>

				<Section theme="light" className="pt-[calc(72px+clamp(40px,6vh,64px))] max-nav:pt-[calc(72px+24px)]">
					<Container className="pt-[clamp(36px,5vh,56px)] pb-[clamp(40px,6vh,64px)] max-nav:pt-0">
						<div className="grid items-start gap-[clamp(32px,5vw,80px)] min-[1101px]:grid-cols-[minmax(0,7fr)_minmax(0,5fr)] min-[1101px]:gap-y-0 nav:max-[1100px]:grid-cols-2 nav:max-[1100px]:gap-10 max-nav:grid-cols-1 max-nav:gap-7">
							<div className="flex justify-center pb-[clamp(32px,5vh,56px)] min-[1101px]:col-span-2 nav:max-[1100px]:order-2 nav:max-[1100px]:self-center nav:max-[1100px]:justify-center nav:max-[1100px]:pb-0 max-nav:-mb-7">
								<Image
									src="/pictures/pols-logo.png"
									alt="POLS Engineering ehf"
									className="h-auto w-[min(100%,460px)] nav:max-[1100px]:w-[min(100%,300px)]"
								/>
							</div>

							<div className="max-[1100px]:contents">
								<ScrollReveal className="block max-nav:order-1 nav:max-[1100px]:order-1 nav:max-[1100px]:self-center">
									<RuleBlock>
										<p className="text-[clamp(20px,1.6vw,24px)] font-semibold leading-[1.35] text-gray-900 text-pretty">
											{t("company_page.intro")}
										</p>
									</RuleBlock>
								</ScrollReveal>

								<ScrollReveal className="mt-8 block max-nav:order-3 max-nav:mt-0 nav:max-[1100px]:order-4 nav:max-[1100px]:mt-0">
									<ul className="divide-y divide-gray-200 border-y border-gray-200">
										{items.map(key => (
											<li
												key={key}
												className="py-4 text-[19px] leading-[1.4] text-gray-900 text-pretty"
											>
												{t(key)}
											</li>
										))}
									</ul>
								</ScrollReveal>
							</div>

							<div className="min-[1101px]:sticky min-[1101px]:top-[104px] max-[1100px]:contents">
								<ScrollReveal className="block max-nav:order-2 nav:max-[1100px]:order-3">
									<figure>
										<Image
											src="/pictures/eski_snow.jpeg"
											alt={t("company_page.caption")}
											className="h-auto w-full rounded-lg shadow-[0_16px_40px_rgba(41,51,92,.12)]"
										/>
										<figcaption className="mt-3 text-[16px] italic text-gray-500">
											{t("company_page.caption")}
										</figcaption>
									</figure>
								</ScrollReveal>
							</div>
						</div>
					</Container>
				</Section>
			</main>

			<Footer />
		</SitePage>
	);
}
